setTimeout(function(){
    $(function() {
        $("#loading").fadeOut();
    });
},3000);
     
$(function() {
    var h = $(window).height();
    $('#loader-bg').height(h).css('display','block');
});
     
setTimeout(function(){
    $('#loader-bg').delay(2000).fadeOut(1000);
});

$(function(){
    setTimeout('stopload()',80000);
});

$(function(){
  var imgHeight = $('#inspiration .slider-area, #process .intoro div').outerHeight();
  var header = $('.header-sticky-wrapper');

  $(window).on('load scroll', function(){
    if ($(window).scrollTop() < imgHeight) {
      header.addClass('headerColor-default');
    }else {
      header.removeClass('headerColor-default');
    }
  });
});

$(function() {
    $('.hamburger').click(function() {
        $(this).toggleClass('active');
 
        if ($(this).hasClass('active')) {
            $('.globalMenuSp').addClass('active');
        } else {
            $('.globalMenuSp').removeClass('active');
        }
    });
});

$(function() {
　$('.globalMenuSp').click(function() {
　　$(this).toggleClass('active');
　if ($(this).hasClass('active')) {
　　$('.hamburger').addClass('active');
　} else {
　　$('.hamburger').removeClass('active');
　}
　});
});

$(function(){
	$('a[href^="#"]').click(function() {
	var speed = 500;
	var href= $(this).attr("href");
	var target = $(href == "#" || href == "" ? 'html' : href);
	var position = target.offset().top;
	$('body,html').animate({scrollTop:position}, speed, 'swing');
	return false;
	});
});

$(function(){
    $(window).scroll(function (){
        $('.fadein').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight + 100){
                $(this).addClass('active');
            }
        });
    });
});

$(function () {
  var width = $(window).width();
  if( width < 768 ){
    $(".swicth_image").each(function(){
      $(this).attr("src", $(this).attr("src").replace("_pc","_sp"));
    })
  }
});

$(function() {
  $('.bxslider').bxSlider({
    auto: true,
    mode: 'fade',
    speed: 800,
    pause: 6000,
    });
});

$(function(){
  var table_len = $('#size-guide').find('table').length;
    if ( table_len == 0 ) {
	$('#size-box').css('display','none');
  }
});

$('.js-drawer-open-nav').on('click', function () {
    $('.js-drawer-close, .js-drawer-open-nav').addClass('rotation');
});

$('.js-drawer-close, .mobile-nav__link').on('click', function () {
    $('.js-drawer-close, .js-drawer-open-nav').removeClass('rotation');
});

$(".mobile-nav__item a").on("click", function() {
  $(".drawer").removeClass("drawer--is-open");
  $(".site-nav__link").removeClass("js-drawer-open-nav");
  $(".js").removeClass("js-drawer-open");
  $(".template-index").removeClass("js-drawer-open");
});

$(window).bind("load", function(){
	if(document.URL.match("/en")) {
      $('.ja').css('display','none');
      $('.en').css('display','block');
	}
});

$(window).on('load',function(){ 
  var url = location.href
  if (url == "https://www.corneliantaurus.com/en/pages/contact"){
    $('.ja').css('display','none');
    $('.en').css('display','flex');
  }
  
});

$(window).bind("load", function(){
	if(document.URL.match("/en")) {
      $("#mv a").attr("href", "/en/blogs/news/limited-store-tokyo-2021-11");      
      $("#philosophy .box1 a").attr("href", "/en/pages/inspiration");
      $("#philosophy .box2 a").attr("href", "/en/pages/process");
      $("#top_collection a").attr("href", "/en/pages/collection");
      $("#top_works .works1 a").attr("href", "/en/pages/art-work");
      $("#top_works .works2 a").attr("href", "/en/pages/archive");
      $("#top_interview a").attr("href", "/en/blogs/interview/");      
      $("#top_other .other1 a").attr("href", "/en/pages/contact");
      $("#top_other .other2 a").attr("href", "/en/pages/retailers-location");
      $("#top_other .other3 a").attr("href", "/en/collections/all"); 
      $("#NavDrawer .appear-delay-2 a").attr("href", "/en#philosophy");
      $("#NavDrawer .appear-delay-5 a").attr("href", "/en/pages/collection");      
      $("footer .footer__item--1605056027938 li:first-child a").attr("href", "/en#philosophy");
      $("footer .footer__item--1605056027938 li:nth-child(4) a").attr("href", "/en/pages/collection");
	}

});

/*
$(window).bind("load", function(){
	var url   = location.href;

	if(url == "https://www.corneliantaurus.com/blogs/interview/"){
		$('#shopify-section-blog-template .medium-up--one-third').addClass('add-class');
	}

});

$(window).bind("load", function(){
	var url   = location.href;

	if(url == "https://www.corneliantaurus.com/en/blogs/interview/"){
		$('#shopify-section-blog-template .medium-up--one-third').addClass('add-class');
	}

});*/

window.addEventListener('DOMContentLoaded', function(){

  const btn_play = document.getElementById("btn_play");
  const btn_pause = document.getElementById("btn_pause");
  const audioElement = document.querySelector("audio");

  btn_play.addEventListener("click", e => {
    audioElement.play();
  });

  btn_pause.addEventListener("click", e => {
    audioElement.pause();
  });
});